module.exports = __webpack_public_path__ + "img/69.70665e6.jpg";